import React from 'react';
import styles from '../detail.module.scss';
import { useNavigate } from 'react-router-dom';

interface SolarRecommendationContext {
    recommendationId: string;
}

interface SolarRecommendationDetailProps {
    context: SolarRecommendationContext;
}

const SolarRecommendationDetail: React.FC<SolarRecommendationDetailProps> = ({ context }) => {
    const navigate = useNavigate();

    return (
        <div className={styles.container}>
            <div className={styles.infoBlock}>
                <div className={styles.row}>
                    <span className={styles.rowLabel}>Recommendation ID</span>
                    <span className={styles.rowValueMono}>{context.recommendationId}</span>
                </div>
            </div>

            <div className={styles.btnContainer}>
                <button className={styles.btn} onClick={() => navigate(`/solar-journey/${context.recommendationId}`)}>
                    View Recommendation
                </button>
            </div>
        </div>
    );
};

export default SolarRecommendationDetail;
